import React from 'react'

import styles from '../styles/components/_imageEditor.module.scss'

const low = 0.1
const high = 2
const step = 0.05

interface ScaleSliderProps {
  scale: number
  onChange: (scale: number) => void
  isMobile: boolean
}

const ScaleSlider: React.FC<ScaleSliderProps> = props => {
  const { scale, onChange, isMobile } = props

  return (
    <div
      id={'active_img_scale_slider'}
      className={
        isMobile ? styles.imageScale : `${styles.imageScale} ${styles.desktop}`
      }
    >
      <div
        style={
          {
            display: 'inline-block',
            position: 'absolute',
            top: -7,
            left: 5,
            fontSize: 25,
            width: 25,
            textAlign: 'center',
          } as React.CSSProperties
        }
        onClick={() => onChange(Math.max(low, scale - step))}
      >
        -
      </div>
      <input
        className={styles.openDrawer}
        name="scale"
        type="range"
        onChange={event => {
          const scale = parseFloat(event.target.value)
          onChange(scale)
        }}
        min={low}
        max={high}
        step={step}
        value={scale}
      />
      <div
        style={
          {
            display: 'inline-block',
            position: 'absolute',
            top: -7,
            right: 5,
            fontSize: 25,
            width: 25,
            textAlign: 'center',
          } as React.CSSProperties
        }
        onClick={() => onChange(Math.min(scale + step, high))}
      >
        +
      </div>
    </div>
  )
}

export default ScaleSlider
